import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { LocalizationComponent } from './localization/localization.component';
import { UserModule } from './user/user.module';
import { LocalizationModule } from './localization/localization.module';
import { KioskConfigurationModule } from './kiosk-configuration/kiosk-configuration.module';
import { TenantConfigurationModule } from './tenant-configuration/tenant-configuration.module';
import { ChecklistModule } from './checklist/checklist.module';
import { LWAReasonsModule } from './lwa-reasons/left-without-assistant-reasons.module';
import { AlertsModule } from './alerts/alerts.module';
import { ProductServicesAppointmentComponent } from './product-services/product-and-services/product-services-appointment/product-services-appointment.component';
import { ProductServicesLobbyComponent } from './product-services/product-and-services/product-services-lobby/product-services-lobby.component';
import { PermissionModule } from './permissions/permissions.module';
import { TranslateModule } from '@ngx-translate/core';
import {DataImportExportModule} from './data-import-export/data-import-export.module';


@NgModule({
  declarations: [AdminComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    UserModule,
    LocalizationModule,
    KioskConfigurationModule,
    TenantConfigurationModule,
    ChecklistModule,
    LWAReasonsModule,
    AlertsModule,
    PermissionModule,
    TranslateModule,
    DataImportExportModule
  ],
})
export class AdminModule { }
